<template>
  <section id="hero">
    <v-img
      :min-height="minHeight"
      :src="require('@/assets/home-grouped-cars.jpg')"
      class="white--text"
      gradient="to right, rgba(5, 11, 31, .8), rgba(5, 11, 31, .8)"
    >
      <v-container class="fill-height px-4 py-12">
        <v-responsive
          class="d-flex align-center"
          height="100%"
          max-width="700"
          width="100%"
        >
          <base-heading title="MANUFACTURING QUALITY PROPSHAFTS SINCE 1996" />

          <base-body>
            Helderberg Propshaft was established in 1996, and has been operating in the Helderberg
            and Overberg Regions. The company has established a wide spread base of customers in
            the area. This was achieved with a philosophy of good and reliable customer service,
            thanks to our dedicated staff who are always ready to give their best. We firmly
            believe that we are a service provider to our customers and not a factory which
            only fix and service propshafts.

            All our suppliers, who we see as partners to our business, conform to ISO 2001
            manufacturing standards and parts are to original equipment specification for
            all the major manufacturers in South Africa.
          </base-body>

          <div
            :class="$vuetify.breakpoint.smAndDown ? 'flex-column align-start' : 'align-center'"
            class="d-flex flex-wrap"
          >
            <base-btn
              to="contact-us"
            >
              Contact Us
            </base-btn>

            <span class="font-weight-bold ml-6 mr-4 my-4">or</span>

            <base-btn
              :ripple="false"
              class="pa-1"
              height="auto"
              text
              to="about"
            >
              See our Products & Services
            </base-btn>
          </div>
        </v-responsive>
      </v-container>
    </v-img>
  </section>
</template>

<script>
export default {
  name: 'SectionHero',

  provide: {
    theme: { isDark: true },
  },

  computed: {
    minHeight() {
      const height = this.$vuetify.breakpoint.mdAndUp ? '100vh' : '50vh';

      return `calc(${height} - ${this.$vuetify.application.top}px)`;
    },
  },
};
</script>
